Vue.component('ack-product-scrolling-content', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-product-scrolling-content',
	props: {
		scrollingItems: {
			// :product-info
			type: Array,
			required: true,
		},
		title: {
			type: String,
			required: true,
		},
		description: {
			type: String,
			required: false,
		},
		isMobile: {
			type: Boolean,
			required: true,
		},
		desHyperLink: {
			type: Object,
			required: false,
			default: () => ({
				hyperLink: '',
			}),
		},
		currentPageId: {
			type: String,
			required: false,
		},
		productHandle: {
			type: String,
			required: false,
			default: '',
		},
	},
	data() {
		return {
			solSeBuildPlatforms: [
				{
					title: 'Large Build Platform',
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Build_Platform_Large_Beige_Model_2.png?v=1782202363',
					mediaBgColor: '#E9EFF4',
					accentColor: '#3a8dde',
					points: [
						'Ideal for printing dental models and multiple full-arch indications.',
						'Ability to print multiple applications for high-volume workloads.',
						'Print area: 5.1 x 3.1 x 4.7 in / 12.9 x 8 x 12 cm',
					],
				},
				{
					title: 'Medium Build Platform',
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Build_Platform_Medium_with_Splint.png?v=1782202362',
					mediaBgColor: '#EEF3EE',
					accentColor: '#2aa6a1',
					points: [
						'Ideal for 3D printing single full-arch or smaller indications with enhanced print efficiency.',
						'A perfect balance between productivity and resin efficiency.',
						'Print area: 2.7 x 2.7 x 4.7 in / 7 x 7 x 12 cm',
					],
				},
				{
					title: 'Small Build Platform',
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Build_Platform_Small_with_crown.png?v=1782202362',
					mediaBgColor: '#F0EDF8',
					accentColor: '#ab65f4',
					points: [
						'Perfect for printing crowns, bridges, surgical guides, castable crowns and gingiva masks.',
						'Allows minimal resin displacement for faster layer settling.',
						'Print area: 1.5 x 0.7 x 4.7 in / 4 x 2 x 12 cm',
					],
				},
			],
			solPlusFeatureImages: [
				{
					title: 'Standard Build Platform',
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/SOL_Plus_Launch_Presentation-07.png?v=1782354940',
					alt: 'Standard Build Platform',
					mediaBgColor: '#E9EFF4',
					accentColor: '#3a8dde',
					points: [
						'Ideal for printing multiple dental models, denture bases, and full-arch indications in a single print run.',
						'Recommended for high-volume workflows, with capacity for up to 8 models printed horizontally.',
						'Print area: 8.6 x 5 x 4.7 in / 21.8 x 12.7 x 12 cm.',
					],
					imageMaxWidth: '82%',
					imageMaxHeight: '82%',
					panelHeight: '260px',
					mediaPadding: '1.5rem',
					imageScale: '1',
					imageOnLeft: true,
				},
				{
					title: 'Arch Build Platform',
					image: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Arch.png?v=1782354936',
					alt: 'Arch Build Platform',
					mediaBgColor: '#EEF3EE',
					accentColor: '#33b2ad',
					points: [
						'Ideal for situations when faster turnaround is preferred, with capacity of up to 3 models printed horizontally.',
						'Compact print area helps reduce resin displacement and shorten wait times between layers for faster printing.',
						'Print area: 5.5 x 3.4 x 4.7 in / 14 x 8.8 x 12 cm',
					],
					imageMaxWidth: '100%',
					imageMaxHeight: '100%',
					panelHeight: '260px',
					mediaPadding: '0.5rem',
					imageScale: '1.18',
					imageOnLeft: false,
				},
			],
		};
	},
});
